const LOAN_BENEFIT = { icon: 'icon-discount', text: 'Access to personalized loans and rates' };
const BUYER_BENEFITS = [{ icon: 'icon-user-home', text: 'Connection with local agent experts' }, { icon: 'icon-home-checked', text: 'Personalized home recommendations' }, LOAN_BENEFIT];

export function getMembershipFormInfo({ requestName, trigger, geoZip, intent } = {}) {
    if (trigger === 'notification') {
        return {
            showLogo: false,
            title: '',
            desc: 'Create your free account to receive new home updates in ' + geoZip + '.',
            panelTitle: '',
            benefits: [],
            buttonText: 'Get Updates',
            showDisclaimer: true,
        };
    }
    if (trigger === 'digsScubscription') {
        return {
            showLogo: false,
            title: 'Own this home?',
            desc: "Get emailed updates to your home's value",
            panelTitle: '',
            benefits: [],
            buttonText: 'Claim Home',
            showDisclaimer: true,
        };
    }
    if (requestName === 'savedsearch') {
        return {
            showLogo: false,
            title: 'Get search alerts with a free membership',
            desc: 'We’ll notify you when homes matching your search hit the market.',
            panelTitle: 'As a member, you also receive:',
            benefits: BUYER_BENEFITS,
            buttonText: 'Save This Search',
            showDisclaimer: true,
        };
    }
    if (requestName === 'addfavorite') {
        return {
            showLogo: false,
            title: 'Save this home with a free membership',
            desc: 'Receive alerts on home availability, price cuts, and open houses.',
            panelTitle: 'As a member, you also receive:',
            benefits: BUYER_BENEFITS,
            buttonText: 'Save Home',
            showDisclaimer: true,
        };
    }
    if (requestName === 'addclaimhome' || requestName === 'simpledppclaim') {
        return {
            showLogo: false,
            title: 'Homeowner membership is free',
            desc: 'Claim your home and everything below comes with it.',
            panelTitle: 'As a member you receive:',
            benefits: [
                { icon: 'icon-graph-increasing', text: 'Track home value and equity' },
                { icon: 'icon-trend-down', text: 'Find ways to reduce monthly payments' },
                { icon: 'icon-payment', text: 'Get cash from your home' },
                LOAN_BENEFIT,
            ],
            buttonText: 'Claim My Home',
            showDisclaimer: true,
        };
    }
    const joinDefault = {
        showLogo: true,
        title: 'Join for free',
        desc: 'With a membership, keep all aspects of your home journey in one place— all it takes is an email.',
        panelTitle: 'As a member you receive:',
        benefits: [
            { icon: 'icon-bell', text: 'Get listing alerts with price and availability updates' },
            { icon: 'icon-graph-increasing', text: 'Track your home’s value and watch your equity grow' },
            LOAN_BENEFIT,
        ],
        buttonText: 'Continue With Email',
        showDisclaimer: true,
    };
    if (intent === 'signin') {
        return {
            showLogo: true,
            title: 'Welcome back',
            desc: 'Your membership picks up right where you left off. Sign in to view your saved homes, searches, and personalized offers.',
            panelTitle: '',
            benefits: [],
            buttonText: 'Continue With Email',
            showDisclaimer: true,
        };
    }
    return joinDefault;
}
